import { Stack } from '@optimus-web/core';
import {
    ConflictingFields,
    ConflictingFieldsProps,
    GuestsInfoSection,
    GuestsInfoSectionProps,
    MatchingFields,
} from './components';

export type MatchesComparisonProps = Pick<GuestsInfoSectionProps, 'setSelectedGuestId'> &
    Pick<
        ConflictingFieldsProps,
        'mergeMode' | 'navigateToNextMatch' | 'matchedGuestProfiles' | 'mergePossible' | 'readOnlyForm'
    >;

export const MatchesComparison = ({ matchedGuestProfiles, setSelectedGuestId, ...other }: MatchesComparisonProps) => {
    const { matchedFields, profiles, confidence } = matchedGuestProfiles;

    return (
        <Stack vertical spacing="800" itemAlignment="center" fill>
            <GuestsInfoSection
                setSelectedGuestId={setSelectedGuestId}
                confidenceLevel={confidence}
                matchingProfiles={profiles}
            />
            <MatchingFields matchedFields={matchedFields} matchingProfile={profiles[0]} />
            <ConflictingFields matchedGuestProfiles={matchedGuestProfiles} {...other} />
        </Stack>
    );
};
